import options from './options';

export default {
  [options.NAME_ASC]: 'Sort by name, A to Z',
  [options.NAME_DESC]: 'Sort by name, Z to A',
  [options.DATE_ASC]: 'Sort by date, old to new',
  [options.DATE_DESC]: 'Sort by date, new to old'
};
